// src/hooks/transportations/useGetTransportation.js
import { useQuery } from "@tanstack/react-query";
import { getTransportation } from "../../api/apiTransportations";
import i18next from "i18next";

const QUERY_KEY = ["transportations"];

const useGetTransportation = (id) => {
    const {
        data,
        isLoading,
        isError,
        error,
    } = useQuery({
        queryKey: [...QUERY_KEY, id, i18next.language],
        queryFn: () => getTransportation(id),
        enabled: !!id,
    });

    return {
        isLoading,
        error: isError ? error : null,
        transportation: data?.data || null,
    };
};

export default useGetTransportation;
